import { bootstrapApplication } from '@angular/platform-browser';

import { AppConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
declare const module: any;
bootstrapApplication(AppComponent, AppConfig).catch((err) =>
  console.error(err)
);
